import React from 'react';
import { Grid, } from 'semantic-ui-react';
import SplitContainer from '@zippytech/react-toolkit/SplitContainer';
import '@zippytech/react-toolkit/SplitContainer/index.css';
import OrganizationTree from "./BrowserPane/OrganizationTree";
import UserTree from "./BrowserPane/UserTree";
import AddSuborganization from "./drive/AddSuborganization";
import SubOrganizationList from "./DesignerPane/OrganizationList";
import OrganizationEvent from "./DesignerPane/OrganizationEvents";
import { Route, withRouter } from 'react-router-dom';
import UsersList from "./DesignerPane/UsersList";
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import { push } from "react-router-redux";
import './OrganizationCommanStyle.css';
import { HelpComponent } from "../../common/HelpComponent";
import AddUser from './drive/AddUsers'
import IndexResourcePane from "./ResourcesPane/Index";
import ManagePermissions from './DesignerPane/ManagePermissions'
import SubOrganizationTeamDetail from './DesignerPane/SubOrganizationTeamDetail'
import SubOrganizationUserDetail from './DesignerPane/SubOrganizationUserDetail'
import ReactResizeDetector from 'react-resize-detector';

class Organization extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            space: '',
            splitAt: "60%",
            browserPaneSplit: "25%",
            setRole: 'Manager',
            teamId: null,
            collapsedResourcePaneIndex: null
        }
    }
    

    componentWillMount() {
        if ((this.props.selectedOrganisation && this.props.selectedOrganisation.role === 'Member') || !this.props.selectedOrganisation) {
            dispatch(push(`/app/${this.props.match.params.accountId}/403`));
        }
        else {
            //dispatch.community.addMainAreaContext('ORGANIZATION');
            dispatch.organizationUnit.clearOrganizationUnit();
            dispatch.community.clearBreadCrumbsOps();
            dispatch.lifeCycle.setLibraryCardIndex(null);
            dispatch.app.setCurrentContext("organization");
            dispatch.organizationUnit.showResourecePane(null)

            dispatch.app.setCollapsedResourcePaneIndexTemp(null)
            dispatch.initiatives.showResourecePane(null);
            dispatch.initiatives.setTabName(null)
            // this.clearFilter();
        }

    }


    componentWillUnmount() {
        //dispatch.initiatives.setSelectedActivityData({});
        this.endFun()
    }
    async endFun() {
        await dispatch.organizationUnit.showResourecePane(null)
        await dispatch.initiatives.showResourecePane(null);
        await dispatch.initiatives.setSelectedActivityData({});
    }

    keyPress = async (e) => {

        if (e.keyCode === 27) {
            dispatch.app.setCollapsedResourcePaneIndexTemp(null)
            await dispatch.organizationUnit.showResourecePane(null)
            this.setState({ collapsedResourcePaneIndex: null })
            dispatch.lifeCycle.updateLibraryCardIndex(null)
            dispatch.invite.updateStateForResource([]);
            dispatch.organizationUnit.showDeleteDisabled(false)
            if (this.props.addUserContext === 'Teams') {
                dispatch.community.addMainAreaContext('ORGANIZATION');
            }
            else if (this.props.addUserContext === 'Users') {
                dispatch.community.addMainAreaContext('USERS');
            }
        }
    }

    onResizeResourcepane = (width, height) => {
        let windowHeight = window.innerHeight
        let designerDimension = {
            width: width,
            windowHeight: windowHeight,
            height: height
        }
        dispatch.initiatives.setDesignerDimension(designerDimension);


        const setUniqueId = this.props.setUniqueId;
        if (setUniqueId) {
            const setPositionElement = document.getElementById(setUniqueId);
            if (setPositionElement) {
                setTimeout(() => {
                    setPositionElement.scrollIntoView({ block: "center", inline: "nearest" });
                }, 100);
            }
        }
    }

    render() {
        let DesignerPane
        if ((this.props.selectedOrganisation && this.props.selectedOrganisation.role === 'Member') || !this.props.selectedOrganisation) {
            return null
        }
        else {
            DesignerPane = <SplitContainer
                orientation="horizontal"
                splitAt={this.props.showResourecePaneFlag && this.props.splitAtSize ? this.props.splitAtSize : "100%"}
                locked={(this.props.showResourecePaneFlag === null)}
                resizeProxy={true}
                onKeyDown={this.keyPress}
                fillSides={[true, true]}
                minSize={["0%", "0%"]}
                maxSize={[null, '81%']}
                collapsible={[true, true]}
                collapsedIndex={this.props.collapsedResourcePaneIndexTemp === 1 || this.props.collapsedResourcePaneIndexTemp === 0 ? this.state.collapsedResourcePaneIndex : this.props.collapsedResourcePaneIndexTemp}
                onResize={(splitAt) => {
                    if (Number(splitAt.replace("%", "")) < 30) {
                        this.setState({ collapsedResourcePaneIndex: 0 })
                        dispatch.app.setCollapsedResourcePaneIndexTemp(0)
                    } else if (Number(splitAt.replace("%", "")) > 80) {
                        this.setState({ collapsedResourcePaneIndex: 1 })
                        dispatch.app.setCollapsedResourcePaneIndexTemp(1)
                    } else {
                        // this.setState({ collapsedResourcePaneIndex: null })
                        dispatch.lifeCycle.splitAt(splitAt)
                        // dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                    }
                }}
                onExpand={() => {
                    this.setState({ collapsedResourcePaneIndex: null })
                    dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                    dispatch.lifeCycle.splitAt("60%")
                }}
                onCollapse={(index) => {
                    this.setState({ collapsedResourcePaneIndex: index })
                    dispatch.app.setCollapsedResourcePaneIndexTemp(index)
                }}
            >
                <SplitContainer.Side className="Split-DesignerPane pad_20">
                    <div>

                        <Route exact path="/app/:accountId/_ws/:workspaceId/_cm"
                            render={() => (
                                <OrganizationEvent name="Organization Events" {...this.props} />
                            )} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_cm/team/:teamId"
                            render={() => (
                                <SubOrganizationList name="Community Team List" {...this.props} />
                            )} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_cm/teamDetail/:teamId"
                            render={() => (
                                <SubOrganizationTeamDetail name="Community Team Details" {...this.props} />
                            )} />
                        <Route path="/app/:accountId/_ws/:workspaceId/_cm/createTeam/:addTeamPageId/:teamId/:parentOrganizationId"
                            render={() =>
                                <AddSuborganization space='Organization Unit' name="Community Add Team" {...this.props} />
                            } />
                        <Route path="/app/:accountId/_ws/:workspaceId/_cm/addUser/:addUserPageId/:teamId/:parentOrganizationId"
                            render={() =>
                                <AddUser name="Community Add User" {...this.props} />
                            } />
                        <Route path="/app/:accountId/_ws/:workspaceId/_cm/userList/:teamId/:userType"
                            render={() =>
                                <UsersList usersList={this.props.usersList} name="Community Participant List"   {...this.props} />
                            } />
                        <Route path="/app/:accountId/_ws/:workspaceId/_cm/userDetail/:teamId/:userType/:userId"
                            render={() =>
                                <SubOrganizationUserDetail name="Community User Details"  {...this.props} />
                            } />
                        <Route path="/app/:accountId/_ws/:workspaceId/_cm/permissions"
                            render={() =>
                                <ManagePermissions  {...this.props} />
                            } />

                    </div>
                </SplitContainer.Side>

                <SplitContainer.Side id="resourceContainer" className="Split-ResourcePane">
                    <ReactResizeDetector handleWidth handleHeight onResize={this.onResizeResourcepane}>
                        <IndexResourcePane {...this.props} />
                    </ReactResizeDetector>
                </SplitContainer.Side>
            </SplitContainer>
        }
        return (
            <SplitContainer
                orientation="vertical"
                minSize="10%"
                maxSize={['50%', null]}
                collapsible={[true, false]}
                fillSides={[true, true]}
                defaultSplitAt="25%"
                collapsedIndex={this.state.collapsedBrowserPaneIndex}
                splitAt={this.state.browserPaneSplit}
                resizeProxy={true}
                onResize={(browserPaneSplit) => {
                    if (Number(browserPaneSplit.replace("%", "")) < 11) {
                        this.setState({ collapsedBrowserPaneIndex: 0 })
                    } else {
                        this.setState({ browserPaneSplit })
                    }
                }}
                onExpand={() => {
                    this.setState({
                        collapsedBrowserPaneIndex: null,
                        browserPaneSplit: "25%"
                    })
                }}
                onCollapse={(index) => {
                    this.setState({
                        collapsedBrowserPaneIndex: index,
                        browserPaneSplit: "25%"
                    })
                }}
            >
                <SplitContainer
                    orientation="horizontal"
                    minSize="10%"
                    collapsible={[false, true]}
                    defaultSplitAt="75%"

                >
                    <SplitContainer.Side className="Split-BrowserPane">
                        <Grid divided className="practiceTree ">
                            <Grid.Row style={{
                                height: "100%",
                                overflow: "auto",
                                padding: 0
                            }}>
                                <Grid.Column
                                    width={8}
                                    className="w_50"
                                    style={{ height: "100%", overflow: "auto", padding: "0" }}>
                                    <OrganizationTree
                                        history={this.props.history}
                                        name="Community Participant Browser"
                                        {...this.props} />
                                </Grid.Column>
                                <Grid.Column
                                    width={8}
                                    className="w_50"
                                    style={{ height: "100%", overflow: "auto", padding: "0" }}>
                                    <UserTree history={this.props.history}
                                        invites={this.props.invites}
                                        organizationId={this.props.selectedOrganisation.id}
                                        orgUniqueId={this.props.orgUniqueId}
                                        executiveList={this.props.executiveList}
                                        managerList={this.props.managerList}
                                        memberList={this.props.memberList}
                                        name="Community Team Browser"
                                        {...this.props}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                    </SplitContainer.Side>
                    <SplitContainer.Side className="Split-HelpPane" >
                        <HelpComponent />
                    </SplitContainer.Side>
                </SplitContainer>
                {DesignerPane}
            </SplitContainer>

        );
    }
}

function mapStateToProps(state) {
    return {
        invitationError: state.invite.invitationError,
        user: state.app.user,
        selectedOrganisation: state.app.selectedOrganisation,
        community: state.community,
        organization: state.organization,
        subOrgError: state.organizationUnit.subOrgError,
        invitations: state.invite.invitations,
        subOrgs: state.organizationUnit.subOrgs,
        selectedSubOrg: state.organizationUnit.selectedSubOrg,
        subOrgsResourcePane: state.organizationUnit.subOrgsResourcePane,
        nodes: state.organizationTab.nodes,
        loading: state.loading.effects.invite.sendInviteAsync,
        showResourecePaneFlag: state.organizationUnit.showResourecePaneFlag,
        userObj: state.users.userObj,
        organizationUnit: state.organizationUnit,
        usersList: state.users.usersList,
        orgUniqueId: state.users.orgUniqueId,
        executiveList: state.users.executiveList,
        managerList: state.users.managerList,
        memberList: state.users.memberList,
        userDelModalOpen: state.users.isUserDelModalOpen,
        userToDel: state.users.userToDel,
        isUserDeactivateModal: state.users.isUserDeactivateModal,
        curIndexPath: state.users.curIndexPath,
        inviteObj: state.invite.inviteObj,
        userTabName: state.users.userTabName,
        showInviteResourcePane: state.invite.showInviteResourcePane,
        inviteUserList: state.invite.inviteUserList,
        userRole: state.invite.userRole,
        searchInvitationsObj: state.invite.searchInvitationsObj,
        libraryCardIndex: state.lifeCycle.libraryCardIndex,
        validationCheck: state.createPack.validationCheck,
        searchUserQuery: state.users.searchUserQuery,
        searchInviteQuery: state.invite.searchInviteeQuery,
        landingPageFlag: state.organizationUnit.landingPageFlag,
        teamUsersArray: state.organizationTab.teamUsersArray,
        searchedUsers: state.users.searchedUsers,
        deactUserData: state.users.deactUserData,
        enableLinkActivity: state.lifeCycle.enableLinkActivity,
        splitAtSize: state.lifeCycle.splitAtSize,
        subOrgInvitaions: state.initiatives.subOrgInvitaions,
        teamList: state.initiatives.teamList,
        activePage: state.organizationUnit.activePage,
        activePaneIndex: state.organizationUnit.activePaneIndex,
        collapsedResourcePaneIndexTemp: state.app.collapsedResourcePaneIndexTemp,
        addSubOrgloading: state.loading.effects.organizationUnit.addSubOrganizationAsync,
        createInvitaionLoader: state.loading.effects.invite.createInvitationAsync,
        addUserInSubUnitLoader: state.loading.effects.invite.addUserInSubUnitAsync,
        searchUserArr: state.invite.searchUserArr,
        searchInviteUserArr: state.invite.searchInviteUserArr,
        selectedAccount: state.app.selectedAccount,
        mainAreaContext: state.community.mainAreaContext,
        addUserContext: state.community.addUserContext,
        invites: state.invite.invites,
        deleteSubOrgloading: state.loading.effects.organizationUnit.deleteSubOrganizationMainAsync,
        teamsListViewFlag: state.app.teamsListViewFlag,
        loaderEventData: state.loading.effects.notifications.getEventStreamByOrganization && state.loading.models.notifications,
        eventStreamArrayForCommunity: state.notifications.eventStreamArrayForCommunity,
        initiativeOwnerDetails: state.initiatives.initiativeOwnerDetails,
        usersWithPermission: state.users.usersWithPermission,
        loadingPermissions: state.loading.effects.users.getAccountUsersWithPermissions && state.loading.models.users,
        eventStreamCount: state.notifications.eventStreamCount,
        recentUpdates: state.notifications.recentUpdates,
        loaderEventStreamForCommunity: state.loading.effects.notifications.getEventStreamForCommunity && state.loading.models.notifications,
        loaderRecentUpdates: state.loading.effects.notifications.getRecentUpdates && state.loading.models.notifications,
        eventStreamArrayForTeam: state.notifications.eventStreamArrayForTeam,
        recentUpdatesForTeam: state.notifications.recentUpdatesForTeam,
        loaderEventStreamForTeam: state.loading.effects.notifications.getEventStreamForTeamId && state.loading.models.notifications,
        loaderRecentUpdatesForTeam: state.loading.effects.notifications.getRecentUpdatesForTeamId && state.loading.models.notifications,
        allInitiativesByTeamId: state.initiatives.allInitiativesByTeamId,
        allInitiativesByUserIdAndTeamId: state.initiatives.allInitiativesByUserIdAndTeamId,
        eventStreamArrayForUserIdAndTeamId: state.notifications.eventStreamArrayForUserIdAndTeamId,
        recentUpdatesForTeamIdAndUserId: state.notifications.recentUpdatesForTeamIdAndUserId,
        loaderEventStreamForTeamIdAndUserId: state.loading.effects.notifications.getEventStreamForUserIdAndTeamId && state.loading.models.notifications,
        loaderRecentUpdatesForTeamIdAndUserId: state.loading.effects.notifications.getRecentUpdatesForTeamIdAndUserId && state.loading.models.notifications,
        allPlaybooksByUserIdAndTeamId: state.lifeCycle.allPlaybooksByUserIdAndTeamId,
        allContentsByUserIdAndTeamId: state.content.allContentsByUserIdAndTeamId,
        userSuborganizationList: state.organizationTab.userSuborganizationList,
        userTreeSelectedPathValue: state.users.userTreeSelectedPathValue,
        redirectFromDashboard: state.home.redirectFromDashboard,
        noEventDataFound: state.home.noEventDataFound,
        organizationCountData: state.organizationUnit.organizationCountData,
        loadingOrganization: state.loading.effects.organizationUnit.getOrganizationCount && state.loading.models.organizationUnit,
        loadingMyOrganization: state.loading.effects.organizationUnit.myCommunityDashboardCount && state.loading.models.organizationUnit,
        // For user Assigned Activity
        componentDesignerDimension: state.initiatives.componentDesignerDimension,
        raciFilterProperties: state.initiatives.raciFilterProperties,
        associatedTeams: state.initiatives.associatedTeams,
        initiativeMemberActivities: state.initiatives.initiativeMemberActivities,
        loadingMyActivities: state.loading.effects.initiatives.getInitiativeActivitiesForMember,
        activityRACIUsers: state.initiatives.activityRACIUsers,
        selectedActivityData: state.initiatives.selectedActivityData,
        advancedFilterProperties: state.initiatives.advancedFilterProperties,
        resourcePaneFlag: state.initiatives.resourcePaneFlag,
        activeTab: state.initiatives.activeTab,
        currentNote: state.initiatives.currentNote,
        initiativeId: state.initiatives.initiativeId,
        publishedContent: state.createPack.publishedContent,
        selectedinitiativeGraph: state.initiatives.selectedinitiativeGraph,
        position: state.initiatives.position,
        initiativeCountDataForMember: state.initiatives.initiativeCountDataForMember,
        raciCount: state.initiatives.raciCount,
        setUniqueId: state.initiatives.setUniqueId,
        selectedDataById: state.initiatives.selectedDataById,
        loadingSingleActivityData: state.loading.effects.initiatives.getSelectedActivityDetails && state.loading.models.initiatives,
        accessToken: state.login.accessToken,
        envData: state.app.envData,
        currentOrganization:state.organizationTab.currentOrganization,
        loadingReplaceDeactivateUserFromOrgAsync:state.loading.effects.users.replaceDeactivateUserFromOrgAsync,
        orgUsers: state.organizationUnit.orgUsers,
        isDeleteDisabled: state.organizationUnit.isDeleteDisabled,
    };
}

const connectedOrganizationPage = withRouter(connect(mapStateToProps)(Organization));
export { connectedOrganizationPage as Organization }; 
